import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

import { getDataType, getAssemblyList } from "../../actions/publish";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
    },
    fullWidth: {
      width: '100%'
    },
    tabBox: {
      width: '100%',
      height: '32px',
      "& .ant-tabs-nav": {
        height: '32px',
        marginBottom: "0 !important",
        "&:before": {
          display: 'none'
        }
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-ink-bar": {
        background: '#07AEA0'
      },
      "& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn": {
        color: '#07AEA0'
      },
      "& .ant-tabs-tab-btn:hover": {
        color: '#07AEA0'
      }
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      "& .ant-table-cell": {
        wordBreak: "break-all !important",
      },
    },
  };
};

class Assembly extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    tabIndex: 0,
    defaultForm: { // 默认值
      NumberOfCatalogue: "",
      NameOfCatalogue: "",
      IssuedDate: [],
      ImplementationDate: [],
      StatuteWebLink: '',
      WebLink: '',
      ComparisonWebLink: '',
    },
    labelObj: {
      NumberOfCatalogue: '编号',
      NameOfCatalogue: '显示名称',
      IssuedDate: '发布日期',
      ImplementationDate: '实施日期',
      StatuteWebLink: '法规链接',
      WebLink: '法规Web链接地址',
      ComparisonWebLink: '对比文件Web链接地址',
    },
    typeId: "",
    dataType: [],
    page: {
      PageNo: 1,
      PageSize: 10,
    },
    total: 0,
    scrollObj: {
      y: 600,
    },
    sortObj: {},
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  componentDidMount() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.initType();
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        NumberOfCatalogue: "",
        NameOfCatalogue: "",
        IssuedDate: [],
        ImplementationDate: [],
        StatuteWebLink: '',
        WebLink: '',
        ComparisonWebLink: '',
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        if (key == 'IssuedDate' || key == 'ImplementationDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initType = () => {
    getDataType().then((res) => {
      let dataType = res.DataList;
      this.setState({
        dataType: dataType,
      });
      this.setState({
        typeId: dataType[0].ID,
      });
      this.initData();
    });
  };

  initData = () => {
    let IssuedDate = this.state.form.IssuedDate
    let ImplementationDate = this.state.form.ImplementationDate
    let param = Object.assign(
      {},
      this.state.form,
      this.state.page,
    );

    if (IssuedDate && IssuedDate.length > 0) {
      param.IssuedDate_KS = IssuedDate[0].format("YYYY-MM-DD")
      param.IssuedDate_JS = IssuedDate[1].format("YYYY-MM-DD")
    }
    delete(param.IssuedDate)
    
    if (ImplementationDate && ImplementationDate.length > 0) {
      param.ImplementationDate_KS = ImplementationDate[0].format("YYYY-MM-DD")
      param.ImplementationDate_JS = ImplementationDate[1].format("YYYY-MM-DD")
    }
    delete(param.ImplementationDate)

    param.TypeID = this.state.typeId;
    getAssemblyList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "编号",
        dataIndex: "NumberOfCatalogue",
        width: 100,
        key: "NumberOfCatalogue",
      },
      {
        title: "显示名称",
        dataIndex: "NameOfCatalogue",
        key: "NameOfCatalogue",
      },
      {
        title: "发布日期",
        dataIndex: "IssuedDate",
        key: "IssuedDate",
        width: 140,
        render: (IssuedDate) => (
          <span>{IssuedDate ? IssuedDate.substring(0, 10) : ''}</span>
        ),
      },
      {
        title: "实施日期",
        dataIndex: "ImplementationDate",
        key: "ImplementationDate",
        width: 140,
        render: (ImplementationDate) => (
          <span>{ImplementationDate ? ImplementationDate.substring(0, 10) : ''}</span>
        ),
      },
      {
        title: "法规链接",
        dataIndex: "StatuteWebLink",
        width: "15%",
        key: "StatuteWebLink",
        render: (StatuteWebLink) => (
          <a href={StatuteWebLink} target="_blank">
            {StatuteWebLink}
          </a>
        ),
      },
      {
        title: "法规Web链接地址",
        dataIndex: "WebLink",
        width: "15%",
        key: "WebLink",
        render: (WebLink) => (
          <a href={WebLink} target="_blank">
            {WebLink}
          </a>
        ),
      },
      {
        title: "对比文件Web链接地址",
        dataIndex: "ComparisonWebLink",
        width: "15%",
        key: "ComparisonWebLink",
        render: (ComparisonWebLink) => (
          <a href={ComparisonWebLink} target="_blank">
            {ComparisonWebLink}
          </a>
        ),
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    let sortKey = sorter.columnKey;
    let order = sorter.order;
    let sortObj = {
      SortCriteria: order ? sortKey : "",
      SortCriteriaMode:
        order == "descend" ? "Desc" : order == "ascend" ? "Asc" : "",
    };
    this.setState(
      {
        filteredInfo: filters,
        sortObj: sortObj,
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {};

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState(
      {
        filteredInfo: null,
        page: {
          PageNo: 1,
          PageSize: 10,
        },
        form: {},
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };



  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.PageNo &&
      pageSize == this.state.page.PageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          PageNo: page,
          PageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  changeTab = (i) => {
    let id = this.state.dataType[i].ID;
    this.setState(
      {
        typeId: id,
        tabIndex: i,
        page: {
          PageNo: 1,
          PageSize: 10,
        },
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">编号</div>
              <Input  value={this.state.form.NumberOfCatalogue}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'NumberOfCatalogue')} 
                placeholder="请输入编号"/>
            </div>

            <div className="form-item">
              <div className="form-label">显示名称</div>
              <Input  value={this.state.form.NameOfCatalogue}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'NameOfCatalogue')} 
                placeholder="请输入显示名称"/>
            </div>

            <div className="form-item">
              <div className="form-label">发布日期</div>
              <RangePicker
                allowClear
                value={this.state.form.IssuedDate}
                onChange={(value) => this.onChangeForm(value, 'IssuedDate')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">实施日期</div>
              <RangePicker
                allowClear
                value={this.state.form.ImplementationDate}
                onChange={(value) => this.onChangeForm(value, 'ImplementationDate')}
              />
            </div>

            <div className="form-item">
              <div className="form-label">法规链接</div>
              <Input  value={this.state.form.StatuteWebLink}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'StatuteWebLink')} 
                placeholder="请输入法规链接"/>
            </div>
            <div className="form-item">
              <div className="form-label">法规Web链接地址</div>
              <Input  value={this.state.form.WebLink}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'WebLink')} 
                placeholder="请输入法规Web链接地址"/>
            </div>
            <div className="form-item">
              <div className="form-label">对比文件Web链接地址</div>
              <Input  value={this.state.form.ComparisonWebLink}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ComparisonWebLink')} 
                placeholder="请输入对比文件Web链接地址"/>
            </div>

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>
        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">法规汇编目录信息</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <div className="main-top">
              <div className={classes.fullWidth}>
                <Tabs
                  onChange={this.changeTab}
                  className={classes.tabBox}
                >
                  {this.state.dataType.map((v, i) => (
                    <TabPane tab={v.TableTypeDisplayName.substring(2)} key={i}></TabPane>
                  ))}
                </Tabs>
              </div>

            </div>

            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Assembly));
